import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Pipeline from "./pages/Pipeline";
import Leads from "./pages/Leads";
import CallDesk from "./pages/CallDesk";
import SmsCenter from "./pages/SmsCenter";
import Followups from "./pages/Followups";
import Analytics from "./pages/Analytics";
import Team from "./pages/Team";
import Sequences from "./pages/Sequences";
import Inbox from "./pages/Inbox";
import AIAgent from "./pages/AIAgent";
import Orchestrator from "./pages/Orchestrator";
import Launch from "./pages/Launch";
import Attention from "./pages/Attention";
import FindLeads from "./pages/FindLeads";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
              <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="attention" element={<Attention />} />
                <Route path="pipeline" element={<Pipeline />} />
                <Route path="leads" element={<Leads />} />
                <Route path="find-leads" element={<FindLeads />} />
                <Route path="call-desk" element={<CallDesk />} />
                <Route path="sms" element={<SmsCenter />} />
                <Route path="followups" element={<Followups />} />
                <Route path="sequences" element={<Sequences />} />
                <Route path="inbox" element={<Inbox />} />
                <Route path="ai-agent" element={<AIAgent />} />
                <Route path="orchestrator" element={<Orchestrator />} />
                <Route path="launch" element={<Launch />} />
                <Route path="team" element={<Team />} />
                <Route path="analytics" element={<Analytics />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </ThemeProvider>
    </div>
  );
}

export default App;
